<template>
  <div>
    <v-row :align="is_field_error ? 'baseline' : 'center'">
      <v-col
        :align="isMobile ? 'left' : 'right'"
        cols="12"
        xs="12"
        sm="12"
        md="3"
        :lg="need_field_spacing ? '2' : '3'"
        :xl="need_field_spacing ? '2' : '3'"
      >
        <p
          style="
            font-weight: bold;
            margin-bottom: 0 !important;
            font-size: 15px;
          "
        >
          <span v-if="is_required" style="color: red">*</span> {{ title }}:
        </p>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="7"
        :lg="need_field_spacing ? '6' : '9'"
        :xl="need_field_spacing ? '6' : '9'"
      >
        <v-text-field :value="v_model" hide-details outlined readonly>
          <template v-slot:append>
            <v-menu
              v-model="menu"
              top
              nudge-bottom="105"
              nudge-left="16"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <div :style="swatchStyle" v-on="on" />
              </template>
              <v-card>
                <v-card-text class="pa-0">
                  <v-color-picker
                    hide-canvas
                    hide-mode-switch
                    mode="hexa"
                    v-model="v_model"
                    swatches-max-height="100"
                    flat
                  />
                </v-card-text>
              </v-card>
            </v-menu>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  // props: ['title'],
  props: {
    title: String,
    v_model: String,
    v_mask: String,
    is_required: Boolean,
    value: String,
    rules: Array,
    read_only: Boolean,
    // placeholder: String,
    // error_message: String,
    need_field_spacing: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      is_field_error: false,
      menu: false,
    };
  },
  methods: {
    update_value() {
      let v_model = this.v_model;
      this.$emit("update_value", v_model);
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
    swatchStyle(value) {
      const { v_model, menu } = this;
      this.$emit("update_value", v_model);

      return {
        backgroundColor: v_model,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
};
</script>

<style>
</style>